import React, { useState } from 'react';
import Loader from './common/Loader';
import { useFetchStaticData } from './data/fetchStaticData';
import { loadXSportDatastoreStaticResources } from './data/sport-utils';
import { unmappedMarkets } from './data/unmapped-markets';
import { getConfiguration, loadLanguage } from './data/utils';
import { isScriptGDPRCompliant } from './data/gdpr-utils';

export let labels = {};
export function setLabels(newLabels) {
    labels = newLabels;
}
export function getLabel(label, fallback) {
    return labels[label] || fallback || '';
}

const defaultAppConfig = require(`./config/${process.env.REACT_APP_XSPORT_CUSTOMER}.conf.json`);

export const appConfig = {
    "PUBLIC_URL":process.env.PUBLIC_URL,
    ...(window.appConfig || defaultAppConfig),
}

appConfig.ROUTES.sectionFromPath = function(path, sections) {
   let section = Object.keys(sections).find(k => sections[k] === path || sections[k] === [path,'/'].join(''));
   const configuration = getConfiguration();

   //If "multi-bet" and "live-suite" have the same path, the returned values depend on configuration
   if(section === 'multi-bet' && sections['live-suite'] === sections['multi-bet']){
        section = configuration.iwh? 'multi-bet' : 'live-suite' 
   }

   return section;
}

appConfig.ROUTES.pathFromSection = function(route,section){
    return appConfig.ROUTES[route][section]
 }

appConfig.ROUTES.routeFromPath = function(path) {
    var toReturn = null;
    Object.entries(appConfig.ROUTES).forEach(function([k, v]) {
        if (!(typeof v === 'function')) {
           if (Object.keys(v).find(k2 => v[k2] === path || v[k2] === `${path}/`)) {
                toReturn =  k;
           }
        }
    });
    return toReturn;
}

function loadScriptsFromDataConfig() {
    const xs_languageCode = loadLanguage();
    const scriptUrls = [];
    const cssHrefs = []
    const configuration = getConfiguration();

    try {
        let widgetURL = configuration['ps']['lte']['BETRADAR_WIDGET']?.['ujs']?.['ALL'];
        if (widgetURL != null) {
            widgetURL = widgetURL.replace('{{lang}}', xs_languageCode.toLowerCase());
            scriptUrls.push(widgetURL);
        }
    } catch(err) {
        console.error(err)
    }

    cssHrefs.forEach(function(h) {
        var lnk = document.querySelectorAll(`link[href="${h}"]`);
        if (!lnk.length) {
            var css = document.createElement('link');
            css.setAttribute("rel", "stylesheet")
            css.setAttribute('href', h);
            document.head.appendChild(css);
        }
    });

    scriptUrls.forEach(function(s) {
        if(isScriptGDPRCompliant(s)){
            var scr = document.querySelectorAll(`script[src="${s}"]`);
            if(!scr.length) {
                var script = document.createElement('script');
                script.setAttribute('src',s);
                document.head.appendChild(script);
            }
        }
       
    });
}

//Useful for checking for mismatch due to cache
function showStaticJsNames() {
    if (window.appConfig?.SHOP_MODE) {
        try {
            const header = document.querySelector("#header #header-terminale-container");
            if(header){
                header.addEventListener("click", function(evt) {
                    var srcs = '';
                    if (evt.detail === 5) {
                        document.querySelectorAll("script[src*='/xsport_desktop/static/js']").forEach(s => {
                            srcs = srcs + (s.src.substring(s.src.lastIndexOf('/')) + '\r');
                        });
                        alert(srcs);
                    };
                })
            }
        } catch(err) {
            console.log(err);
        }
    }
}

function InitData(props) {
    window.appConfig = appConfig;
    appConfig.BASENAME = window.appConfig?.BASENAME ?? process.env.PUBLIC_URL;
    const [onInitState,setOnInitState] = useState(false);

    if (window.xs_ag === undefined) {
        window.xs_ag = {
            betById: {},
            aggregatePrematchBySportId: {},
            aggregateLiveByIdSport: {},
            agsByBetId : {},
            agsByBetIdAndSportId : {}
        };
    }
    const [state] = useFetchStaticData();

    if (state.isLoading) {
        return null;
    }
    if (state.isError) {
        return <Loader error={state.isError} />;
    }

    if (!onInitState) {
        showStaticJsNames();
      
        loadXSportDatastoreStaticResources();
     
        loadScriptsFromDataConfig();
    
        const onInit = window.appConfig.HANDLERS?.['onInitComplete'];
        if (typeof onInit === 'function') {
            onInit();
        }

        unmappedMarkets.fetch();
        setOnInitState(true);
    }

    return (
        <>
            {props.children}
        </>
    );
}

export default InitData;